
import {map} from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { Http, Response  } from '@angular/http';
import { HttpClient  } from '@angular/common/http';
import {Observable} from 'rxjs'

import { environment } from '../../environments/environment'
import {GDSCredentials} from '../core/'

@Injectable()
export class DefaultsService {
  private _defaultBARKeywords = "BEST AVAILABLE, BEST RATE, “BEST UNRESTRICTED”, FLEX, FLEXIBLE";
  private domainStr: string;
  private gdsCodes = [
    {text:"Amadeus", value:3},
    {text:"Apollo", value:2},
    {text:"Galileo", value:5},
    {text:"Sabre", value:1},
    {text:"Worldspan", value:4}
  ];
  RIABASE_URL = "api/RIA/";

  constructor(private http: Http, private httpNext: HttpClient) {
    this.domainStr = environment.baseWebApiUrl;
  }

    public GetDefaultBarKeywords()
    {
        return this._defaultBARKeywords;
    }

    DefaultCredentials(){

    }
    getDefaultGDSCredentials( ):Observable<GDSCredentials>{
     return this.httpNext.get<GDSCredentials>(this.domainStr + this.RIABASE_URL +"GetDefaultCredentials").pipe(
        map(response => { return  response}));
   }

   getLookupCurrencyCodes( ):Observable<any>{
    return this.http.get(this.domainStr + this.RIABASE_URL + "GetLookupCurrencyCodes",{}).pipe(
       map(response => { return  response.json()}),);
  }

  //receive a list of codes that exist for the currently selected audit
  //return a new array comprised of those elements of this.gdsCodes that match the list from the server
  public GetGDSCodes(serverGDSCodeList:Array<string>):Array<{text:string, value:number}>{
    let output = [];
    if(serverGDSCodeList && serverGDSCodeList.indexOf) {
      this.gdsCodes.forEach(element => {
        if(serverGDSCodeList.indexOf(element.text.toUpperCase())>-1) {
          output.push(element);
        }
      });
    }
    return output;
  }
  public GetGDSCode(gdsCode:string):{text:string, value:number} {
    let output = {
      text: '',
      value: -1
    }
    if(gdsCode) {
      this.gdsCodes.forEach(element => {
        if(element.text.toUpperCase()==gdsCode.toUpperCase()) {
          output = element;
        }
      });
      return output;
    }
    return {
      text: 'Default GDS Code',
      value: 0
    };
  }
  //used by the custom report for Rate Availability
  // given the name of a field, returns a javascript id for accessing the data
  // point for that field
  GetJavascriptIdFromFieldName(field:string):string{
    let javascriptId = field.replace(/[\/ ]/ig, '');
    switch(javascriptId) {
      case 'HotelName':
        javascriptId = 'Name';
        break;
    }
    return javascriptId;
  }
  public GetCustomReportTitleStatus(status){
    let value:string = '';
    switch(status) {
      case 'AVAILABLE':
        value = 'Available';
        break;
      case 'AVAILABLEHIGHER':
        value = 'Available Higher';
        break;
      case 'AVAILABLELOWER':
        value = 'Available Lower';
        break;
      case 'RATENOTAVAILABLE':
        value = 'Rate Not Available';
        break;
      case 'HOTELNOTAVAILABLE':
        value = 'Hotel Not Available';
        break;
    }
    return value;
  }

}
